import { Div, Row } from "@/styles/layout";
import { Body } from "@/styles/typography";
import MyPopover from "./Popover";
import { ChromePicker } from "react-color";

const ColorPicker = ({
  label,
  color,
  onSelect,
}: {
  label: string;
  color: string;
  onSelect: (e: string) => void;
}) => (
  <Row alignItems="center" justifyContent={"space-between"} mb="8px">
    <Body mr="16px" fontSize="14px">
      {label}
    </Body>
    <MyPopover
      trigger={
        <Div
          borderRadius="4px"
          width={32}
          height={32}
          bg={color}
          boxShadow="0px 0px 1px black"
        />
      }
      content={
        <ChromePicker
          color={color}
          onChangeComplete={(c) => onSelect(c.hex)}
          disableAlpha
        />
      }
    />
  </Row>
);

export default ColorPicker;
